




















































import Vue from "vue";

import { PermissionName } from "../mixins/permission";

export default Vue.extend({
  data() {
    const menuDatas = [
      {
        title: "Promotion",
        icon: "fa-gift",
        subMenus: [
          {
            title: "Promotion List",
            path: "PromotionViewPage",
            permission: PermissionName.PROMOTION_VIEW
          },
          {
            title: "Create New Promotion",
            path: "PromotionCreatePage",
            permission: PermissionName.PROMOTION_CREATE
          },
          {
            title: "Check Promotion",
            path: "PromotionCheckPage",
            permission: PermissionName.PROMOTION_VIEW
          }
        ]
      },
      {
        title: "User Management",
        icon: "fa-user",
        subMenus: [
          {
            title: "User List",
            path: "UserViewPage",
            permission: PermissionName.USER_VIEW
          },
          {
            title: "Create New User",
            path: "UserCreatePage",
            permission: PermissionName.USER_CREATE
          }
        ]
      },
      {
        title: "Role/Permission",
        icon: "fa-user-check",
        subMenus: [
          {
            title: "Permission List",
            path: "PermissionViewPage",
            permission: PermissionName.PERMISSION_VIEW
          },
          {
            title: "Role List",
            path: "RoleViewPage",
            permission: PermissionName.ROLE_VIEW
          },
          {
            title: "Create New Role",
            path: "RoleCreatePage",
            permission: PermissionName.ROLE_CREATE
          }
        ]
      },
      {
        title: "Migrate To V3",
        icon: "fa-file-export",
        subMenus: [
          {
            title: "Export Customer ",
            path: "MigrateExportCustomerPage",
            permission: PermissionName.MIGRATE_ACTION
          },
          {
            title: "Export Category",
            path: "MigrateExportCategoryPage",
            permission: PermissionName.MIGRATE_ACTION
          },
          {
            title: "Export Product",
            path: "MigrateExportProductPage",
            permission: PermissionName.MIGRATE_ACTION
          },
          {
            title: "Export Inventory",
            path: "MigrateExportInventoryPage",
            permission: PermissionName.MIGRATE_ACTION
          }
        ]
      },
      {
        title: "Order",
        icon: "fa-shopping-cart",
        subMenus: [
          {
            title: "Check Duplicate Order",
            path: "OrderCheckDuplicatePage",
            permission: PermissionName.DUPLICATE_VIEW
          },
          {
            title: "Update Delivery Mode",
            path: "OrderUpdateDeliveryModePage",
            permission: PermissionName.UPDATE_DELIVERY_MODE
          },
          {
            title: "Hold Order",
            path: "OrderHoldPage",
            permission: PermissionName.HOLD_ORDER_STATUS
          },
          {
            title: "Hold Order List",
            path: "OrderHoldListPage",
            permission: PermissionName.HOLD_ORDER_LIST
          },
          {
            title: "Update Mc Status to 5",
            path: "OrderUpdateMcStatusPage",
            permission: PermissionName.UPDATE_MC_STATUS_TO_5
          }
        ]
      },
      {
        title: "Fix Order",
        icon: "fa-wrench",
        subMenus: [
          {
            title: "Recover Order Item",
            path: "FixOrderRecoverItemPage",
            permission: PermissionName.FIX_ACTION
          }
        ]
      },
      {
        title: "Error Tracking",
        icon: "fa-exclamation-circle",
        subMenus: [
          {
            title: "Apply Promotion",
            path: "ErrorTrackingApplyPromotionViewPage",
            permission: PermissionName.APPLY_PROMOTION_ERROR_TRACKING_VIEW
          },
          {
            title: "Incorrect Inventory",
            path: "ErrorTrackingIncorrectInventoryViewPage",
            permission: PermissionName.INCORRECT_INVENTORY_ERROR_TRACKING_VIEW
          }
        ]
      },
      {
        title: "Shop notification",
        icon: "fa-shopping-bag",
        subMenus: [
          {
            title: "Create register token",
            path: "ShopCreateTokenPage",
            permission: PermissionName.CREATE_SHOP_NOTI_TOKEN
          }
        ]
      },
      {
        title: "Shopify",
        icon: "fa-store",
        subMenus: [
          {
            title: "Shopify List",
            path: "ShopifyViewPage",
            permission: PermissionName.SHOPIFY_VIEW
          },
          {
            title: "Shopify Create",
            path: "ShopifyCreatePage",
            permission: PermissionName.SHOPIFY_CREATE
          }
        ]
      },
      {
        title: "Shipnity",
        icon: "fa-shopping-bag",
        subMenus: [
          {
            title: "Shipnity List",
            path: "ShipnityViewPage",
            permission: PermissionName.SHIPNITY_VIEW
          },
          {
            title: "Shipnity Create",
            path: "ShipnityCreatePage",
            permission: PermissionName.SHIPNITY_CREATE
          }
        ]
      },
      {
        title: "Line",
        icon: "fab fa-line",
        subMenus: [
          {
            title: "Line List",
            path: "LineViewPage",
            permission: PermissionName.LINE_VIEW
          },
          {
            title: "Line Create",
            path: "LineCreatePage",
            permission: PermissionName.LINE_CREATE
          },
          {
            title: "Line Schedule Stop Sync",
            path: "LineStopSyncViewPage",
            permission: PermissionName.LINE_STOP_SYNC
          }
        ]
      },
      {
        title: "Marketplace",
        icon: "fa-shopping-cart",
        subMenus: [
          {
            title: "Schedule Stop Sync",
            path: "MarketplaceStopSyncViewPage",
            permission: PermissionName.MARKETPLACE_STOP_SYNC
          }
        ]
      },
      {
        title: "Delivery",
        icon: "fa-truck",
        subMenus: [
          {
            title: "Shop Set Attribute",
            path: "DeliveryModeListPage",
            permission: PermissionName.SHOP_DELIVERY_SET_ATTRIBUTE
          },
          {
            title: "Raw Status Mapping",
            path: "DeliveryMappingList",
            permission: PermissionName.DELIVERY_RAW_STATUS_MAPPING
          }
        ]
      },
      {
        title: "Register COD",
        icon: "fa-money-bill",
        subMenus: [
          {
            title: "Shippop",
            path: "ShippopCreateCodPage",
            permission: PermissionName.SHIPPOP_COD_CREATE
          }
        ]
      },
      {
        title: "Bridge System",
        icon: "fab fa-connectdevelop",
        subMenus: [
          {
            title: "Bridge System List",
            path: "BridgeSystemViewPage",
            permission: PermissionName.API_BRIDGE_ACTION
          },
          {
            title: "Bridge System Queue Orders",
            path: "BridgeSystemQueueOrderPage",
            permission: PermissionName.API_BRIDGE_ACTION
          },
          {
            title: "Bridge System Success Orders",
            path: "BridgeSystemSuccessOrderPage",
            permission: PermissionName.API_BRIDGE_ACTION
          }
        ]
      },
      {
        title: "TMS Registration",
        icon: "fab fa fa-address-book",
        subMenus: [
          {
            title: "Shop Register",
            path: "ShopRegisterTMSPage",
            permission: PermissionName.TMS_REGISTRATION
          }
        ]
      },
      {
        title: "Event notification",
        icon: "fa-exclamation-circle",
        subMenus: [
          {
            title: "Error event",
            path: "ErrorEventViewPage",
            permission: PermissionName.ERROR_EVENT_NOTIFICATION
          },
          {
            title: "Error notification",
            path: "ErrorEventNotificationViewPage",
            permission: PermissionName.ERROR_EVENT_NOTIFICATION
          }
        ]
      }
    ];

    return { menuDatas, drawer: true, mini: true };
  },
  computed: {
    menus() {
      return (this as any).menuDatas
        .map((menuData: any) => {
          const subMenus = menuData.subMenus.filter((subMenu: any) =>
            (this as any).hasPermission(subMenu.permission)
          );

          return { ...menuData, subMenus };
        })
        .filter((menuData: any) => menuData.subMenus.length > 0);
    }
  },
  methods: {
    goToPage(name: string) {
      this.$router.push({ name });
    },
    isPageActive(name: string) {
      return this.$route.name === name;
    }
  }
});
